import { useCallback } from 'react';
import type { TFunction } from 'i18next';
import type { ReservationBooking } from '../services/reservation-system/reservation-board.service';

type UseRsBoardConfirmActionsArgs = {
  t: TFunction;
  hasShareUrl: boolean;
  issueShare: () => void;
  revokeShare: () => void;
  /** パスワード有無に関わらず削除確認モーダルを開く */
  openDeleteModal: (booking: ReservationBooking) => void;
};

/** 共有URL再発行／停止と予約削除の確認 */
export function useRsBoardConfirmActions({
  t,
  hasShareUrl,
  issueShare,
  revokeShare,
  openDeleteModal,
}: UseRsBoardConfirmActionsArgs) {
  const handleIssueShare = useCallback(() => {
    if (
      hasShareUrl &&
      !window.confirm(
        t('reservation.board.shareUrlReissueConfirm', {
          defaultValue: 'URLを再発行すると、以前のURLは使えなくなります。よろしいですか？',
        })
      )
    ) {
      return;
    }
    issueShare();
  }, [hasShareUrl, issueShare, t]);

  const handleRevokeShare = useCallback(() => {
    if (
      !window.confirm(
        t('reservation.board.shareUrlRevokeConfirm', {
          defaultValue: '共有URLを停止します。よろしいですか？',
        })
      )
    ) {
      return;
    }
    revokeShare();
  }, [revokeShare, t]);

  const requestDeleteBooking = useCallback(
    (booking: ReservationBooking) => {
      openDeleteModal(booking);
    },
    [openDeleteModal]
  );

  return { handleIssueShare, handleRevokeShare, requestDeleteBooking };
}
